import moment from 'moment';

moment.suppressDeprecationWarnings = true;

export default moment;